import { useToast } from '../../hooks/useToast';

import { Toast } from './Toast';

export const ToastContainer = () => {
  const { toast, hideToast } = useToast();

  if (!toast) return null;

  const { isVisible, message } = toast;

  return <Toast isVisible={isVisible} message={message} onClose={hideToast} />;
};
